(() => {
  const root = document.querySelector('.ig-page');
  if (!root) return;
  const select = root.querySelector('#ig-pack-select');
  const packs = [...root.querySelectorAll('[data-pack]')];
  const search = root.querySelector('#ig-search');
  const filter = root.querySelector('#ig-filter');
  const status = root.querySelector('#ig-results');
  let active = 'variety';
  function fromHash() {
    const key = location.hash.replace('#pack-', '');
    if (packs.some(p => p.dataset.pack === key)) active = key;
  }
  function update() {
    const query = search.value.trim().toLocaleLowerCase();
    const tag = filter.value;
    const filtering = Boolean(query || tag);
    let matched = 0, pending = 0, total = 0;
    select.value = active;
    packs.forEach(pack => {
      pack.hidden = pack.dataset.pack !== active;
      if (pack.hidden) return;
      const cards = [...pack.querySelectorAll('.ig-card')];
      cards.forEach(card => {
        const unresolved = card.dataset.pending === 'true';
        // Pending formulas always remain visible: lack of data cannot mean ingredient-free.
        const match = (!query || (card.querySelector('h3').textContent + ' ' + card.querySelector('.ig-ingredients').textContent).toLocaleLowerCase().includes(query)) && (!tag || card.dataset.tags.split(' ').includes(tag));
        card.hidden = !unresolved && !match;
        if (unresolved) pending++; else if (match) matched++;
        total++;
      });
      pack.querySelector('.ig-empty').hidden = !filtering || matched > 0;
      pack.querySelector('.ig-pending-note').hidden = !filtering || !pending;
    });
    status.textContent = filtering ? `${matched} matching ingredient ${matched === 1 ? 'entry' : 'entries'}${pending ? ` · ${pending} pending ${pending === 1 ? 'entry' : 'entries'} kept visible` : ''}` : `${total} treat & flavor entries${pending ? ` · ${pending} with details pending` : ''}`;
  }
  root.querySelector('.ig-tools').hidden = false;
  root.querySelector('.ig-pack-picker').hidden = false;
  select.addEventListener('change', () => {
    active = select.value;
    history.replaceState(null, '', '#pack-' + active); update();
  });
  search.addEventListener('input', update);
  filter.addEventListener('change', update);
  root.querySelector('#ig-reset').addEventListener('click', () => {search.value='';filter.value='';update();});
  window.addEventListener('hashchange', () => {fromHash();update();});
  fromHash(); update();
})();
